import { PercentRankMeasuresService } from "../service/asyncBatchPercentRankMeasuresService";
import * as validations from "../utils/validations";

export class PercentRankMeasuresFunctions {
  fnBurgissUniverseCalcValuationPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcValuationPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcMIRRPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcMIRRPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcRIRRPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcRIRRPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcDistributionsPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcDistributionsPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcNetCashFlowPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcNetCashFlowPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcPaidInCapitalPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcPaidInCapitalPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcGGS_DirectAlphaPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcGGS_DirectAlphaPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcKS_PMEPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 2);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 2 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcKS_PMEPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMIRRPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcLN_ICMIRRPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMIRRSpreadPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcLN_ICMIRRSpreadPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMValuationSpreadPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    value = validations.ChkvalidPercentRankValueUptoFourDecimal(value, 4);
    if (value.toString().includes("Error Decimal")) {
      return "#INVALIDPARAMETERS - Value should have maximum of 4 decimal places";
    } else if (value.toString().includes("Mandatory")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Mandatory", "") + "";
    } else if (value.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Invalid", "") + "";
    } else if (value.toString().includes("Formaterror")) {
      return "#INVALIDPARAMETERS - " + value.toString().replace("Formaterror", "") + "";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new PercentRankMeasuresService().burgissUniverseCalcLN_ICMValuationSpreadPercentRank(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRRPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRRPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_QTDPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_QTDPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_YTDPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_YTDPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_1YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_1YearPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_3YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_3YearPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_5YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_5YearPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_10YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_10YearPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_15YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_15YearPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcIRR_20YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcIRR_20YearPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcDPIPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcDPIPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcRVPIPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcRVPIPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }

  fnBurgissUniverseCalcTVPIPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    const PercentRank = validations.isValidPercentRankValue(value);
    if (PercentRank == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (PercentRank == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new PercentRankMeasuresService().burgissUniverseCalcTVPIPercentRank(
      peergroupID,
      value,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
}
